"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTag = void 0;
const vue_1 = require("vue");
const Tags_1 = require("../../cards/Tags");
exports.CardTag = vue_1.default.component('CardTag', {
    props: {
        index: {
            type: Number,
            required: true,
            validator: (i) => i < 4,
        },
        type: {
            type: String,
            required: true,
            validator: (type) => Object.values(Tags_1.Tags).includes(type),
        },
    },
    methods: {
        getClasses: function () {
            const classes = ['card-tag'];
            classes.push(`tag-${this.type.toLocaleLowerCase()}`);
            return classes.join(' ');
        },
    },
    template: `
        <div :class="getClasses()" />
    `,
});
//# sourceMappingURL=CardTag.js.map